import { Controller } from '@hotwired/stimulus'

const AUTO_CLOSE_DELAY = 5000

export default class extends Controller {
  static values = {
    autoClose: { type: Boolean, default: false },
    closingClass: { type: String, default: 'message-panel--closing' }
  }

  connect() {
    if (this.autoCloseValue) {
      this.timer = setTimeout(() => this.close(), AUTO_CLOSE_DELAY)
    }
  }

  disconnect() {
    clearTimeout(this.timer)
  }

  close() {
    clearTimeout(this.timer)
    this.dispatch('close')
    this.element.classList.add(this.closingClassValue)

    const element = this.element
    const handleTransitionEnd = (event) => {
      if (event.target !== element || event.propertyName !== 'opacity') return

      element.removeEventListener('transitionend', handleTransitionEnd)
      element.remove()
    }
    element.addEventListener('transitionend', handleTransitionEnd)
  }
}
